import { __decorate } from "tslib";
import { LitElement, css, html, property, customElement } from 'lit-element';
import { baseStyles } from './styles';
let CdsGridFooter = class CdsGridFooter extends LitElement {
    constructor() {
        super(...arguments);
        this.slot = 'footer';
    }
    static get styles() {
        return [baseStyles, css `
      .private-host {
        min-height: var(--cds-global-space-11);
        display: flex;
        align-items: center;
        padding: 0 var(--cds-global-space-5);
        border-top: var(--cds-alias-object-border-width-100) solid var(--cds-alias-object-border-color);
        color: var(--cds-global-typography-color-500);
      }

      ::slotted(cds-inline-button) {
        --color: var(--cds-global-typography-color-500);
      }
    `];
    }
    render() {
        return html `
      <div class="private-host">
        <slot></slot>
      </div>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true })
], CdsGridFooter.prototype, "slot", void 0);
CdsGridFooter = __decorate([
    customElement('cds-grid-footer')
], CdsGridFooter);
export { CdsGridFooter };
//# sourceMappingURL=grid-footer.element.js.map